import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { CommonUtil } from '../../core/Utils/common-util';
import {RootScopeService} from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.css'],
  styles: ['a.textLink{color: #fff;cursor: pointer;margin: 1rem 0 0;text-decoration: underline!important;}'],
  encapsulation: ViewEncapsulation.None
})
export class CookieBannerComponent implements OnInit, OnDestroy {
  rootScopeData: RootScopeDeclare;
  currentFacility: FacilityObject;

   private sub = new Subscription();

  constructor(private rootScopeService: RootScopeService, public commonUtil: CommonUtil,
    private _facilityService: FacilityService) { }
  
  ngOnInit() { 
    this.getRootScopeData();
    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    const facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
      this.currentFacility = res;
    });
    this.sub.add(facilityOnChange);

    const facilitiesBs = this._facilityService.facilitiesBs$.subscribe(data => {
      this.rootScopeData.isCookieBannerClosed = data.hasCookieConsent === 'true';
    })
    this.sub.add(facilitiesBs);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  async closeCookieBanner() {
    try {
      this.rootScopeData.isCookieBannerClosed = true;
      const body = { 'hasCookieConsent': true };
      await this._facilityService.updatedFacilityPreferenceForUser2(body);
    } catch (error) {
      console.error('API failed.');
    }
  }

  trackInnerHtmlClick(event: MouseEvent) {
    if ((<HTMLElement>event.target).className === 'textLink') {
      window.open(`${environment.currentHostPath}/halo.html#/termsOfUse?locale=${this.rootScopeData.selectedLang}&country=${this.currentFacility.summary.countryIsoCode}&selectedTncTab=cookiePolicy&developerMode=false`,'_blank');
      this.closeCookieBanner(); }

  }
}
